<template>
  <div
    style="display: inline-block; height: 100%; margin: 5px"
    v-if="currentUserData.associations.length > 0"
    class="float-right row justify-center align-center"
  >
    <q-card bordered flat class="cursor-pointer assocSelectorHover">
      <div class="q-pa-sm associationSelectorContent">
        <h4 class="q-my-none" style="font-size: 1.5rem; font-weight: bold">
          {{ currentUserData.currentAssociation.association_abbr }}
          <div style="width: 100px; display: inline-block" class="q-px-sm">
            <q-img :src="currentUserData.currentAssociation.capUrl"></q-img>
          </div>
        </h4>
      </div>
      <q-menu auto-close>
        <div
          v-for="(association, index) in currentUserData.associations"
          :key="`association_${index}`"
          class="assocSelectorHover cursor-pointer"
          @click="updateUserAssociation(association)"
        >
          <div class="q-pa-sm associationSelectorContent">
            <h4 class="q-my-none" style="font-size: 1.5rem; font-weight: bold">
              {{ association.association_abbr }}
              <div style="width: 100px; display: inline-block" class="q-px-sm">
                <q-img :src="association.capUrl"></q-img>
              </div>
            </h4>
          </div>
        </div>
      </q-menu>
    </q-card>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        siteCFG: "settings/siteCFG",
      }),
    },
    data: () => ({}),
    mounted() {},
    methods: {
      async updateUserAssociation(association) {
        this.$store.dispatch("auth/updateUserAssociation", {
          currentAssociation_id: association.id,
        });

        this.$router.push("/");
      },
    },
  };
</script>

<style lang="scss" scoped>
  .associationSelectorContent {
    width: 350px;
    text-align: right;
  }

  .assocSelectorHover {
    transition: background-color 3s ease;
    -webkit-transition: background-color 0.6s ease;
    -o-transition: background-color 0.6s ease;

    :hover {
      background: #eeeeee;
    }
  }
</style>
